import { Box } from "@mui/material";
import { HOME_LAYOUT_HEIGHT } from "../../app/common";
import DashboardGreeting from "./DashboardGreeting";
import DashboardGridLayout from "./DashboardGridLayout";
import DashboardOrders from "./orders/DashboardOrders";
import DashboardTalents from "./talents/DashboardTalents";
import HrTasklistContainer from "./tasklist/HrTasklistContainer";

const DASHBOARD_MAX_HEIGHT = "1440px";

const Dashboard = () => {
  return (
    <Box
      data-testid="dashboard-page-root"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: `calc(${HOME_LAYOUT_HEIGHT} + 16px)`,
        maxHeight: DASHBOARD_MAX_HEIGHT,
        minHeight: 0,
      }}
    >
      <DashboardGreeting />
      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <DashboardGridLayout
          // TODO: add Interviews component to the top section
          top={<></>}
          left={<HrTasklistContainer />}
          right={[
            <DashboardTalents key="dashboardTalents" />,
            <DashboardOrders key="dahboardOrders" />,
          ]}
        />
      </Box>
    </Box>
  );
};

export default Dashboard;
